import React from 'react'
import { Checkbox } from 'semantic-ui-react';
import PropTypes from "prop-types";

const CheckBoxToggle = ({ onChange, value,...rest }) => {
    const onCheckboxChange = (e, data) => {
        if(onChange){
        onChange(data.checked)
        }
    }
    return <Checkbox toggle onChange={onCheckboxChange} defaultChecked={value} {...rest} />
}
CheckBoxToggle.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.bool
}

export default CheckBoxToggle;
